import React, { useEffect, useRef, useState } from "react";
import filter from "../assets/images/filter.png";
import { useDispatch, useSelector } from "react-redux";
import {
  getStudent,
  newUserStatus,
  studentStatus,
} from "../features/slices/studentManagementReducer";
import moment from "moment";
import { Link } from "react-router-dom";
import CommonPagination from "../components/CommonPagination";
import ExportToExcel from "../components/ExportToExcel";
import { canPerformAction } from "../utils/denyAccess";
import { FaCircleInfo } from "react-icons/fa6";
import Modal from "../components/Modal";
import axiosInstance from "../features/axiosInstance";
import { toastService } from "../utils/toastify";


const initialState = {
  currentPage: 1,
  searchQuery: "",
  fromDate: "",
  toDate: "",
  timeframe: "",
  status: "",
};

const initialFormState = {
  fullName: "",
  email: "",
  password: "",
  phoneNumber: "",
  dob: "",
  school: "",
  grade: "",
  profilePic: "",
  userName: "",
  bio: "",
  location: "",
};

const StudentManagement = () => {
  const [iState, setUpdateState] = useState(initialState);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState(initialFormState);
  const [loading, setLoading] = useState(false);
  const { currentPage, searchQuery, fromDate, toDate, timeframe, status } =
    iState;
  const dispatch = useDispatch();
  const studentManagementRef = useRef();
  const { studentData } = useSelector((state) => {
    return state?.student;
  });

  const totalCount = studentData?.result?.[0]?.totalCount?.[0]?.count || 0;
  const itemsPerPage = 10;
  const startIndex = (currentPage - 1) * itemsPerPage + 1;
  const endIndex = Math.min(currentPage * itemsPerPage, totalCount);

  useEffect(() => {
    dispatch(getStudent({ page: currentPage }));
    window.scrollTo(0, 0);
  }, [currentPage]);

  const handleStatus = (e, id) => {
    const value = e.target.checked ? "ACTIVE" : "INACTIVE";
    const data = { id: id, status: value };
    dispatch(studentStatus(data)).then((data) => {
      if (data?.payload?.code === 200) {
        dispatch(getStudent({ page: currentPage })).then((data) => {
          if (data?.payload?.code === 200) {
            setUpdateState((prev) => ({
              ...prev,
              status: "",
            }));
          }
        });
      }
    });
  };
  const handleTimeFrame = (e) => {
    const queryParams = { timeframe: e.target.value };
    setUpdateState((prev) => ({
      ...prev,
      timeframe: e?.target?.value,
    }));
    dispatch(getStudent(queryParams)).then((data) => {
      if (data?.payload?.code === 200) {
      }
    });
  };

  const handlePageChange = (pageNumber) => {
    setUpdateState((prev) => ({
      ...prev,
      currentPage: pageNumber,
    }));
  };
  const handleReset = () => {
    setUpdateState(initialState);
    dispatch(getStudent({ currentPage: 1 }));
  };
  const handleSearch = (e) => {
    const { name, value } = e.target;
    setUpdateState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleFilter = (e) => {
    const status = e.target.value;
    setUpdateState((prev) => ({
      ...prev,
      status: status,
    }));
    dispatch(
      getStudent({
        status: status,
      })
    );
  };
  useEffect(() => {
    if (searchQuery?.trim() !== "") {
      const delayDebounceFunc = setTimeout(() => {
        dispatch(getStudent({ search: searchQuery?.trim() })).then((res) => {
          if (res?.payload?.code == 200) {
            // setUpdateState((prev) => ({
            //   ...prev,
            //   searchQuery: "",
            // }));
          }
        });
      }, 1000);
      return () => clearTimeout(delayDebounceFunc);
    }
  }, [searchQuery, dispatch]);
  const handleSubmit = () => {
    const queryParams = {
      page: 1,
      search: searchQuery?.trim(),
      status: status,
    };
    if (fromDate && toDate) {
      queryParams.startDate = fromDate;
      queryParams.endDate = toDate;
    } else if (timeframe) {
      queryParams.timeframe = timeframe;
    }
    dispatch(getStudent(queryParams)).then((data) => {
      if (data?.payload?.code === 200) {
        setUpdateState((prev) => ({
          ...prev,
          searchQuery: "",
          fromDate: "",
          toDate: "",
          timeframe: "",
        }));
      }
    });
  };
  const newUserHandler = async (id) => {
    const response = await dispatch(newUserStatus({ userId: id }))
    if (response?.payload?.code == 200) {
      dispatch(getStudent({ page: currentPage }));
    }
  }

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleAddStudent = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await axiosInstance.post('/addUser', formData);
      if (response.data.code === 200) {
        toastService.success('Student added successfully');
        setShowModal(false);
        setFormData(initialFormState);
        dispatch(getStudent({ page: currentPage }));
      } else {
        toastService.error(response.data.message || 'Failed to add student');
      }
    } catch (error) {
      toastService.error(error.response?.data?.message || 'An error occurred');
    } finally {
      setLoading(false);
    }
  };

  const closeModal = () => {
    setShowModal(false);
    setFormData(initialFormState);
  };

  const data = [
    { label: '7', value: '7' },
    { label: '8', value: '8' },
    { label: '9', value: '9' },
    { label: '10', value: '10' },
    { label: '11', value: '11' },
    { label: '12', value: '12' }
  ];

  return (
    <div className="WrapperArea">
      <div className="WrapperBox">
        <div className="FilterArea">
          <div className="FilterLeft">
            <div className="form-group">
              <label>From Date</label>
              <input
                type="date"
                className="form-control"
                value={fromDate}
                disabled={timeframe}
                name="fromDate"
                onChange={(e) => handleSearch(e)}
              />
            </div>
            <div className="form-group">
              <label>To Date</label>
              <input
                type="date"
                className="form-control"
                name="toDate"
                value={toDate}
                disabled={timeframe}
                onChange={(e) => handleSearch(e)}
              />
            </div>
            <div className="form-group">
              <label>&nbsp;</label>
              <button className="Button" onClick={handleSubmit}>
                Apply
              </button>
            </div>
            <div className="form-group">
              <label>Timeframe</label>
              <select
                className="form-control"
                name="timeframe"
                value={timeframe}
                disabled={fromDate || toDate}
                onChange={(e) => handleTimeFrame(e)}
              >
                <option value="" hidden>
                  Select
                </option>
                <option value="Today">Today</option>
                <option value="Week">This Week</option>
                <option value="Month">This Month</option>
              </select>
            </div>
          </div>
        </div>
        <div className="Small-Wrapper">
          <div className="NewFilter">
            <div
              className="SearchBox"
              style={{
                width: "60%",
              }}
            >
              <input
                type="search"
                className="SearchInput"
                placeholder="Search here by ID, Name, or Others"
                name="searchQuery"
                value={searchQuery}
                onChange={(e) => handleSearch(e)}
              />
              <span>
                <i className="fa fa-search" />
              </span>
            </div>

            <div className="Actions">
              <div
                className="form-group"
                style={{
                  textAlign: "center",
                }}
              >
                {/* <label
                  style={{
                    fontWeight: "bolder",
                  }}
                >
                  Filter by Status
                </label> */}
                <select
                  className="form-control FilterStatus"
                  value={status}
                  name="status"
                  onChange={(e) => handleFilter(e)}
                >
                  <option value="" hidden>
                    Filter by Status
                  </option>
                  <option value="ACTIVE">ACTIVE</option>
                  <option value="INACTIVE">INACTIVE</option>
                </select>
              </div>
              <button className="Button Cancel" onClick={handleReset}>
                <i className="fa fa-refresh" />
              </button>
              <button className="Button Cancel" onClick={() => setShowModal(true)}>
                <i className="fa fa-user" /> Add New Student
              </button>
              <ExportToExcel
                ref={studentManagementRef}
                fileName="studentData"
              />
            </div>
          </div>
          <div className="TableList">
            <table className="table-hover" ref={studentManagementRef}>
              <thead>
                <tr>
                  <th>Sr. No</th>
                  <th>Student ID</th>
                  <th>Name</th>
                  <th>Mobile No.</th>
                  <th>Email Id</th>
                  <th>Date of Registration</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {studentData?.result?.[0]?.paginationData.map((data, i) => {
                  return (
                    <tr key={data?._id}>
                      <td>{i + 1 + (currentPage - 1) * 10}</td>
                      <td>{data?.user_number}</td>
                      <td>
                        <div className="fw500 position-relative">
                          <div className="mr-2">{data?.fullName}</div>
                          {data?.isNewUser &&
                            // <img src={require("../assets/images/esclamination.png")} onClick={() => newUserHandler(data?._id)} />

                            <small className="circleInfo" onClick={() => newUserHandler(data?._id)}><FaCircleInfo />

                            </small>
                          }

                        </div>
                      </td>
                      <td>
                        <div className="fw500">{data?.phoneNumber}</div>
                      </td>
                      <td>{data?.email}</td>
                      <td>{moment(data?.createdAt).format("MM-DD-YYYY")}</td>
                      <td>
                        <span
                          className={
                            data?.userStatus === "ACTIVE" ? "Green" : "Red"
                          }
                        >
                          {data?.userStatus}
                        </span>
                      </td>
                      <td>
                        <div className="Actions">
                          <Link
                            to={"studentDetails"}
                            className="Eyes"
                            state={data}
                          >
                            <i className="fa-regular fa-eye" />
                          </Link>
                          {canPerformAction("Student") && (
                            <label className="switch">
                              <input
                                type="checkbox"
                                checked={
                                  data?.userStatus === "ACTIVE" ? true : false
                                }
                                onChange={(e) => handleStatus(e, data?._id)}
                              />
                              <span className="slider" />
                            </label>
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div className="Pagination">
            {studentData?.result?.[0]?.totalCount?.[0]?.count > 0 && (
              <>
                <p>
                  Showing {startIndex} to {endIndex} of {totalCount} results
                </p>
                <div className="PaginationRight">
                  <CommonPagination
                    activePage={currentPage}
                    itemsCountPerPage={itemsPerPage}
                    totalItemsCount={
                      studentData?.result?.[0]?.totalCount?.[0]?.count || 0
                    }
                    pageRangeDisplayed={4}
                    onChange={handlePageChange}
                    itemClass="page-item"
                    linkClass="page-link"
                  />
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      {showModal && (
        <Modal>
          <div className="modal-header">
            <h5 className="modal-title">Add New Student</h5>
            <button type="button" className="close" onClick={closeModal}>
              <span>&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <form onSubmit={handleAddStudent}>
              <div className="form-group">
                <label>Full Name</label>
                <input
                  type="text"
                  className="form-control"
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleFormChange}
                  placeholder="Enter full name"
                  required
                />
              </div>
              <div className="form-group">
                <label>Email</label>
                <input
                  type="email"
                  className="form-control"
                  name="email"
                  value={formData.email}
                  onChange={handleFormChange}
                  placeholder="Enter email address"
                  required
                />
              </div>
              <div className="form-group">
                <label>Password</label>
                <input
                  type="password"
                  className="form-control"
                  name="password"
                  value={formData.password}
                  onChange={handleFormChange}
                  placeholder="Enter password"
                  required
                />
              </div>
              {/* <div className="form-group">
                <label>Phone Number</label>
                <input
                  type="text"
                  className="form-control"
                  name="phoneNumber"
                  value={formData.phoneNumber}
                  onChange={handleFormChange}
                  placeholder="Enter phone number"
                  required
                />
              </div> */}

              <div className="form-group">
                <label>Phone Number</label>
                <input
                  type="tel"
                  className="form-control"
                  name="phoneNumber"
                  value={formData.phoneNumber}
                  onChange={(e) => {
                    // allow only digits
                    const value = e.target.value.replace(/\D/g, "");

                    // limit to 10 digits
                    if (value.length <= 10) {
                      handleFormChange({
                        target: {
                          name: "phoneNumber",
                          value: value
                        }
                      });
                    }
                  }}
                  placeholder="Enter phone number"
                  pattern="[0-9]{10}"
                  maxLength={10}
                  required
                />
              </div>
              <div className="form-group">
                <label>Date of Birth</label>
                <input
                  type="date"
                  className="form-control"
                  name="dob"
                  value={formData.dob}
                  onChange={handleFormChange}
                  placeholder="Select date of birth"
                  required
                />
              </div>
              <div className="form-group">
                <label>School</label>
                <input
                  type="text"
                  className="form-control"
                  name="school"
                  value={formData.school}
                  onChange={handleFormChange}
                  placeholder="Enter school name"
                  required
                />
              </div>

              <div className="form-group">
                <label>Grade</label>
                <select
                  className="form-control"
                  name="grade"
                  value={formData.grade}
                  onChange={handleFormChange}
                  required
                >
                  <option value="">Select grade</option>
                  {data.map((item, index) => (
                    <option key={index} value={item.value}>
                      {item.label}
                    </option>
                  ))}
                </select>
              </div>
              {/* <div className="form-group">
                <label>Grade</label>
                <input
                  type="text"
                  className="form-control"
                  name="grade"
                  value={formData.grade}
                  onChange={handleFormChange}
                  placeholder="Enter grade"
                  required
                />
              </div> */}
              {/* <div className="form-group">
                <label>Profile Picture URL</label>
                <input
                  type="url"
                  className="form-control"
                  name="profilePic"
                  value={formData.profilePic}
                  onChange={handleFormChange}
                  placeholder="Enter profile picture URL"
                />
              </div> */}
              <div className="form-group">
                <label>Username</label>
                <input
                  type="text"
                  className="form-control"
                  name="userName"
                  value={formData.userName}
                  onChange={handleFormChange}
                  placeholder="Enter username"
                  required
                />
              </div>
              <div className="form-group">
                <label>Bio</label>
                <textarea
                  className="form-control"
                  name="bio"
                  value={formData.bio}
                  onChange={handleFormChange}
                  placeholder="Enter bio"
                />
              </div>
              <div className="form-group">
                <label>Location</label>
                <input
                  type="text"
                  className="form-control"
                  name="location"
                  value={formData.location}
                  onChange={handleFormChange}
                  placeholder="Enter location"
                />
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={closeModal}>
                  Cancel
                </button>
                <button type="submit" className="btn btn-primary" disabled={loading}>
                  {loading ? 'Adding...' : 'Add Student'}
                </button>
              </div>
            </form>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default StudentManagement;
